import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Box, Inline, Stack, Text } from '@travel-frontend/core';
import { IconPhone } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import illustration from '../../../../assets/images/contactIllustration.svg';
import { NextImage } from '../../../../components/internal/NextImage/index.js';
import { Spinner } from '../../../../components/TravelDetailsOverlay/components/Contact/components/Spinner.js';
import { Button, Notice } from '../../../../primitives/index.js';
export const Contact = ({
  hotline,
  openingHours,
  offerCodeEnabled,
  offerCodeStatus,
  offerCodeData: offerCode
}) => {
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  return _jsxs(Stack, {
    space: "pages/small",
    align: "center",
    children: [_jsx(Box, {
      display: "flex",
      children: _jsx(NextImage, {
        image: illustration,
        width: 200,
        alt: ""
      })
    }), _jsx(Text, {
      preset: "headlineLarge",
      children: t('contact.title')
    }), offerCodeEnabled && _jsxs(Stack, {
      space: "8px",
      align: "center",
      children: [_jsx(Text, {
        preset: "paragraphMedium",
        children: t('contact.offerCodeHint')
      }), _jsxs(Inline, {
        alignY: "center",
        space: "8px",
        style: {
          minHeight: 34
        },
        children: [(offerCodeStatus === 'not-executed' || offerCodeStatus === 'loading') && _jsxs(_Fragment, {
          children: [_jsx(Spinner, {}), _jsx(Text, {
            preset: "paragraphMedium",
            children: t('contact.offerCodeLoading')
          })]
        }), offerCodeStatus === 'success' && _jsx(Text, {
          preset: "paragraphMediumBold",
          children: t('contact.offerCodeLabel', {
            offerCode
          })
        }), offerCodeStatus === 'error' && _jsx(Notice, {
          variant: "warning",
          children: t('contact.offerCodeError')
        })]
      })]
    }), _jsxs(Stack, {
      space: "8px",
      align: "center",
      children: [_jsx(Button, {
        as: "a",
        href: `tel:${hotline}`,
        variant: "interaction",
        icon: _jsx(IconPhone, {}),
        children: hotline
      }), _jsx(Text, {
        preset: "paragraphMedium",
        children: t('contact.hotlineOpeningHours', {
          openingHours
        })
      })]
    })]
  });
};